/* eslint-disable react/prop-types */
import React, { useState } from "react";
import moment from "moment";
import styled from 'styled-components';

import { isDateExpired } from 'Core/helpers/date';
import PaymentModal from "../Chat/PaymentModal";

const ConsultationsInfo = ({ expirationsDate }) => {
  const formattedDate = `${moment(expirationsDate).format("D MMMM YYYY")}`;
  const isInvalidDate = formattedDate === 'Invalid date';
  const [isOpenedModel, setIsOpenedModel] = useState(false);

  return (
    <ConsultationsContainer>
      {isInvalidDate || isDateExpired(expirationsDate) ? (
        <ExpiredStatus>
          <span>{isInvalidDate ? 'Консультации не активны' : 'Консультации закончились'}</span>
        </ExpiredStatus>
      ) : (
        <ActiveStatus>
          <span>
            Консультации до
            {' '}
            {formattedDate}
          </span>
        </ActiveStatus>
      )}

      <ExtendButton to="/extend-consultations" onClick={() => setIsOpenedModel(true)}>
        {isInvalidDate ? 'Купить консультации' : 'Продлить консультации'}
      </ExtendButton>

      {isOpenedModel && (
        <PaymentModal closeModal={() => setIsOpenedModel(false)} />
      )}
    </ConsultationsContainer>
  );
};

export default ConsultationsInfo;

// Стилизованные компоненты
const ConsultationsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8fafc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
  border: 1px solid #e2e8f0;
`;

const ActiveStatus = styled.div`
  color: #38a169;
  font-weight: 500;
`;

const ExpiredStatus = styled.div`
  color: #e53e3e;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const ExtendButton = styled.button`
  background: #4299e1;
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  transition: background 0.2s;
  border: none 0;
  outline: none 0;
  
  &:hover {
    background: #3182ce;
  }

  &:hover,
  &:active,
  &:focus {
    outline: none 0;
  }
`;
